/**
 * Maillage interne — pages prioritaires à faire crawler / indexer.
 * Ces liens sont rendus dans le footer (sitewide) et via <RelatedLinks />
 * sur les pages qui ont déjà de l'autorité, pour pousser Google vers
 * les URL « découvertes mais non indexées ».
 */

export type InternalLink = { to: string; label: string; params?: Record<string, string> };

export const FOOTER_LINK_GROUPS: { title: string; links: InternalLink[] }[] = [
  {
    title: "Mariage",
    links: [
      { to: "/dj-mariage", label: "DJ mariage Provence" },
      { to: "/dj-mariage/$ville", params: { ville: "vaucluse" }, label: "DJ mariage Vaucluse" },
      { to: "/dj-mariage/$ville", params: { ville: "avignon" }, label: "DJ mariage Avignon" },
      { to: "/dj-mariage/$ville", params: { ville: "luberon" }, label: "DJ mariage Luberon" },
      { to: "/dj-mariage/$ville", params: { ville: "alpilles" }, label: "DJ mariage Alpilles" },
      { to: "/dj-mariage/$ville", params: { ville: "aix-en-provence" }, label: "DJ Aix-en-Provence" },
      { to: "/dj-mariage/$ville", params: { ville: "evangelique" }, label: "DJ mariage évangélique" },
      { to: "/dj-mariage/pack-sono-lumiere", label: "Pack sono & lumière mariage" },
      { to: "/ciel-etoile-mariage", label: "Ciel étoilé mariage" },
      { to: "/guide-mariage-vaucluse", label: "Guide mariage Vaucluse" },
    ],
  },
  {
    title: "Location matériel",
    links: [
      { to: "/location-materiel", label: "Location matériel son & lumière" },
      { to: "/location-sono-mariage", label: "Location sono mariage" },
      { to: "/location-karaoke-vaucluse", label: "Location pack karaoké Avignon & Vaucluse" },
      { to: "/location-photobooth-avignon", label: "Location photobooth Avignon" },
      { to: "/location-materiel/$slug", params: { slug: "enceintes-actives" }, label: "Location enceintes actives" },
      { to: "/location-materiel/$slug", params: { slug: "photobooth" }, label: "Location photobooth" },
      { to: "/location-materiel/$slug", params: { slug: "videoprojecteur" }, label: "Vidéoprojecteur & écran" },
      { to: "/location-materiel/$slug", params: { slug: "machine-fumee-lourde" }, label: "Machine à fumée lourde" },
      { to: "/conditions-de-location", label: "Conditions de location" },
    ],
  },
  {
    title: "Événements",
    links: [
      { to: "/dj-vaucluse", label: "DJ Vaucluse" },
      { to: "/soirees-evenements", label: "Soirées & événements" },
      { to: "/dj-saint-sylvestre", label: "DJ Saint-Sylvestre" },
      { to: "/dj-entreprise/$ville", params: { ville: "avignon" }, label: "DJ soirée entreprise Avignon" },
      { to: "/dj-anniversaire/$ville", params: { ville: "cavaillon" }, label: "DJ anniversaire Cavaillon" },
      { to: "/location-gender-reveal", label: "Gender reveal" },
      { to: "/soirees-thematiques", label: "Soirées thématiques" },
      { to: "/sono-lumiere", label: "Sonorisation & lumière" },
    ],
  },
  {
    title: "DJ Val",
    links: [
      { to: "/lieux", label: "Domaines & lieux de réception" },
      { to: "/tarifs", label: "Tarifs DJ" },
      { to: "/calculateur", label: "Calculateur de devis" },
      { to: "/realisations", label: "Réalisations" },
      { to: "/avis-clients", label: "Avis clients" },
      { to: "/le-concept", label: "Le concept" },
      { to: "/a-propos", label: "À propos" },
      { to: "/actualites", label: "Actualités" },
    ],
  },
  {
    title: "Domaines & lieux",
    links: [
      { to: "/lieux", label: "Tous les lieux de réception" },
      { to: "/lieux/$slug", params: { slug: "domaine-malaugo" }, label: "Domaine Malaugo" },
      { to: "/lieux/$slug", params: { slug: "domaine-de-l-ermitage" }, label: "Domaine de l'Ermitage" },
      { to: "/lieux/$slug", params: { slug: "domaine-des-maillettes" }, label: "Domaine des Maillettes" },
      { to: "/lieux/$slug", params: { slug: "domaine-la-chartreuse" }, label: "Domaine La Chartreuse" },
      { to: "/lieux/$slug", params: { slug: "domaine-d-egenia" }, label: "Domaine d'Egenia" },
      { to: "/lieux/$slug", params: { slug: "la-grange-de-javon" }, label: "La Grange de Javon" },
      { to: "/lieux/$slug", params: { slug: "le-petit-roulet" }, label: "Le Petit Roulet" },
      { to: "/lieux/$slug", params: { slug: "domaine-de-manville" }, label: "Domaine de Manville" },
    ],
  },
  {
    title: "Zones d'intervention",
    links: [
      { to: "/dj-avignon", label: "DJ Avignon" },
      { to: "/dj-vaucluse", label: "DJ Vaucluse" },
      { to: "/dj-anniversaire/$ville", params: { ville: "cavaillon" }, label: "DJ Cavaillon" },
      { to: "/dj-mariage/$ville", params: { ville: "luberon" }, label: "DJ Luberon" },
      { to: "/dj-mariage/$ville", params: { ville: "alpilles" }, label: "DJ Alpilles" },
      { to: "/dj-mariage/$ville", params: { ville: "aix-en-provence" }, label: "DJ Aix-en-Provence" },
      { to: "/dj-mariage/$ville", params: { ville: "bouches-du-rhone" }, label: "DJ Bouches-du-Rhône" },
    ],
  },
];


/** Blocs contextuels « À découvrir aussi » par page hôte. */
export const RELATED_LINKS: Record<string, InternalLink[]> = {
  home: [
    { to: "/dj-vaucluse", label: "DJ Vaucluse — toutes les prestations du département" },
    { to: "/dj-mariage/$ville", params: { ville: "vaucluse" }, label: "DJ mariage Vaucluse" },
    { to: "/location-sono-mariage", label: "Location sono pour mariage" },
    { to: "/location-materiel/$slug", params: { slug: "karaoke" }, label: "Pack karaoké complet dès 200 €" },
    { to: "/guide-mariage-vaucluse", label: "Guide complet du mariage en Vaucluse" },
    { to: "/lieux", label: "Les domaines où j'interviens" },
  ],
  tarifs: [
    { to: "/calculateur", label: "Estimer votre devis en 1 minute" },
    { to: "/dj-mariage/pack-sono-lumiere", label: "Pack sono & lumière mariage" },
    { to: "/location-sono-mariage", label: "Location sono mariage (sans DJ)" },
    { to: "/location-materiel/$slug", params: { slug: "karaoke" }, label: "Pack karaoké complet dès 200 €" },
    { to: "/dj-vaucluse", label: "DJ Vaucluse — zones desservies" },
    { to: "/conditions-de-location", label: "Conditions de location" },
  ],
  materiel: [
    { to: "/location-sono-mariage", label: "Location sono spéciale mariage" },
    { to: "/location-materiel/$slug", params: { slug: "karaoke" }, label: "Pack karaoké complet dès 200 €" },
    { to: "/location-materiel/$slug", params: { slug: "enceintes-actives" }, label: "Location enceintes actives" },
    { to: "/location-photobooth-avignon", label: "Location photobooth Avignon & Vaucluse dès 190 €" },
    { to: "/location-gender-reveal", label: "Pack gender reveal" },
    { to: "/dj-vaucluse", label: "DJ Vaucluse — prestation complète" },
    { to: "/conditions-de-location", label: "Conditions & caution" },
  ],
};
